<template>
    <div>
        <table v-if="layout.selectedComponent" class="table mt-2 border-bottom"
               style="margin-bottom: 0px;font-size: .85rem;">
            <tbody>

            <tr class="info-row">
                <td colspan="2" class="editor-content bg-primary text-white">
                    <strong>Field Type - {{field.field_type}}</strong>
                </td>
            </tr>

            <tr v-if="view.view_type === 'form'">
                <td class="editor-content editor-label">Required</td>
                <td class="editor-content">
                    <input type="checkbox" v-model="selectedComponent.required">
                </td>
            </tr>

            <tr v-if="isImageType">
                <td class="editor-content editor-label">Use as background</td>
                <td class="editor-content">
                    <input type="checkbox" v-model="selectedComponent.metadata.isBackgroundImage"
                           @change="onBgImageChanged">
                </td>
            </tr>

            <tr v-if="isTextType && view.view_type !== 'form'">
                <td class="editor-content editor-label">Display as</td>
                <td class="editor-content">
                    <select class="form-control editor-form editor-select"
                            v-model="selectedComponent.metadata.renderType" @change="onRenderTypeSelected">
                        <option>Label</option>
                        <option>Header</option>
                    </select>
                </td>
            </tr>

            </tbody>
        </table>

        <component-properties v-if="this.selectedComponent.component && this.selectedComponent.component.type"
                              :component="this.selectedComponent.component"
                              :layout="layout" :view="view"></component-properties>
    </div>
</template>

<script>
    import MarginSelector from "./MarginSelector.vue";
    import ComponentProperties from "./ComponentProperties.vue";
    import PageFactory from "../../utils/PageFactory";

    export default {
        name: 'FieldProperties',
        components: {ComponentProperties, MarginSelector},
        props: ['layout', 'view', 'page'],
        data() {
            return {
                model: webase.model,
                pageFactory: new PageFactory()
            }
        },
        computed: {
            selectedComponent() {
                return this.layout.selectedComponent
            },
            field() {
                return this.selectedComponent.value
            },
            isImageType() {
                let isImage = this.field.field_type === 'Image'

                if (isImage && !this.selectedComponent.metadata) {
                    this.selectedComponent.metadata = {
                        isBackgroundImage: false
                    }
                }

                return isImage
            },
            isTextType() {
                let isString = this.field.field_type === 'String'

                if (isString && !this.selectedComponent.metadata) {
                    this.selectedComponent.metadata = {
                        renderType: 'Label'
                    }
                }

                return isString
            }
        },
        mounted() {
            if(!this.selectedComponent.component) {
                this.selectedComponent.component = {}
            }
        },
        methods: {
            onBgImageChanged() {
                if (this.selectedComponent.metadata.isBackgroundImage) {
                    console.log(this.layout.selectedRow)
                    this.layout.selectedRow.background.field_id = this.field.id
                }
            },
            onRenderTypeSelected() {
                if (this.selectedComponent.metadata.renderType === 'Label') {
                    this.selectedComponent.component = this.pageFactory.createHtmlComponent('Label', '')
                } else if (this.selectedComponent.metadata.renderType === 'Header') {
                    this.selectedComponent.component = this.pageFactory.createHtmlComponent('Header', '')
                }
            }
        }
    }
</script>

<style>

</style>
